<template>
  <div id="app">
    <v-header></v-header>
    <router-view />
  </div>
</template>

<script>
import vHeader from "@/components/Header.vue";
export default {
  components: { vHeader },
  name: "App",
  mounted () {
    this.getchannel();
    const script = document.createElement('script');
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1279738988&web_id=1279738988'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },

  watch: {
    '$route': {
      handler (to, from) {
        setTimeout(() => { //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = '/';
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
            window._czc.push(["_setAutoPageview", false]);
          }
        }, 300)
      },
      immediate: true  // 首次进入页面即执行
    }
  },
  methods: {
    //  changeLang() {
    //   let locale = localStorage.getItem("language") || "zh";
    //   console.log(locale,'locale')
    //   let temp = locale === "zh" ? "en" : "zh";
    //   this.$i18n.locale = temp; //改变当前语言
    //   localStorage.language = temp;
    // }
    getchannel () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      this.$store.commit('changechannel', flag)
    },
  }
};
</script>

<style>
#app {
  font-family: "Noto Sans SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
.container {
  width: 100%;
}
.showeditbox img {
  max-width: 100%;
  height: auto !important;
}
body > a:first-child {
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/App.vue